export default {
    stickers: {
        title: 'Klistre­mærker',
        stickerOpacity: 'Gennemsigtighed for klistermærker',
        stickerColor: 'Klistermærkefarve',
        shapes: {
            title: 'Former',
            rectangle: 'Rektangel',
            circle: 'Cirkel',
            triangle: 'Trekant',
        },
        emojis: {
            title: 'Emojis',
        },
    },
};
